const VALUES_PER_PAGE = {
  TEN: 10,
  TWENTY: 20,
  THIRTY: 30,
  FORTY: 40
};

export { VALUES_PER_PAGE };
